const Joi = require("@hapi/joi");

module.exports = Joi.object({
	name: Joi.string().messages({
		"any.required": "Name is required"
	}),
	mail: Joi.string()
		.required()
		.email({ minDomainSegments: 2, tlds: false })
		.messages({
			"string.email": "Email must have email format",
			"any.required": "Email is required"
		}),
	subject: Joi.string()
		.required()
		.messages({
			"any.required": "Subject is required"
		}),
	message: Joi.string()
		.required()
		.messages({
			"any.required": "Message is required"
		})
});
